export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">投稿合作</h2>
          <p className="text-sm text-foreground-500 mb-10">
            欢迎影评人、影视创作者和品牌方与我们联系，共同为影迷打造更丰富的高清观影生态
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="bg-background-50 rounded-xl p-6 border border-background-200/70">
              <div className="w-10 h-10 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                <i className="ri-article-line text-lg text-accent-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">影评投稿</h3>
              <p className="text-xs text-foreground-500">分享你的观影心得</p>
              <p className="text-xs text-accent-600 mt-2 font-medium">contrib@jisumovie.com</p>
            </div>

            <div className="bg-background-50 rounded-xl p-6 border border-background-200/70">
              <div className="w-10 h-10 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                <i className="ri-team-line text-lg text-accent-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-500">品牌推广与资源置换</p>
              <p className="text-xs text-accent-600 mt-2 font-medium">biz@jisumovie.com</p>
            </div>

            <div className="bg-background-50 rounded-xl p-6 border border-background-200/70">
              <div className="w-10 h-10 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                <i className="ri-bug-line text-lg text-accent-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">问题反馈</h3>
              <p className="text-xs text-foreground-500">遇到问题随时告诉我们</p>
              <p className="text-xs text-accent-600 mt-2 font-medium">support@jisumovie.com</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}